import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { Card, Button, Field, PasswordInput } from "../../components/ui-kit";

export default function ClientChangePassword() {
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (next.length < 12) { toast.error("La nuova password deve avere almeno 12 caratteri"); return; }
    if (next !== confirm) { toast.error("Le due password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password aggiornata");
      nav("/app");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto space-y-6" data-testid="client-change-password-page">
      <div>
        <p className="text-xs uppercase tracking-[0.18em] text-slate-400 font-body">Il tuo account</p>
        <h1 className="font-heading text-3xl font-bold">Cambia password</h1>
        <p className="mt-1 text-sm text-slate-500">Il consulente mantiene comunque la possibilità di reimpostarla in qualsiasi momento dal pannello di gestione.</p>
      </div>
      <Card className="p-6 space-y-4">
        <Field label="Password attuale *"><PasswordInput value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="change-pwd-current" /></Field>
        <Field label="Nuova password *" hint="Almeno 12 caratteri"><PasswordInput minLength={12} value={next} onChange={(e) => setNext(e.target.value)} data-testid="change-pwd-new" /></Field>
        <Field label="Conferma nuova password *"><PasswordInput minLength={12} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="change-pwd-confirm" /></Field>
        <Button variant="success" className="w-full" loading={loading} onClick={submit} data-testid="change-pwd-submit"><KeyRound className="w-4 h-4" /> Salva nuova password</Button>
      </Card>
    </div>
  );
}
